"use strict";
import {whenValid} from "@elements/parsley-bootstrap-validation";

export function initInScope ($scope) {
    let $navLinks = $scope.find('.js-profile-nav-link');
    if( $navLinks.length === 0) {
        return;
    }else{
        let $form = $scope.find('.js-profile-nav-link__form');
        if( $form.length === 0) {
            return;
        }
        $navLinks.each(function (index, navLink) {
            const $navLink = $(navLink); // Ensure navLink is wrapped in a jQuery object
            $navLink.on('click', function (e) {
                e.preventDefault();
                whenValid($form).then((isValid) => {
                    if (isValid) {
                        const navHref = $(this).attr('href'); // Store the href of the nav item
                        const formData = new FormData($form[0]);
                        $.ajax({
                            url: $form.attr('data-action'),
                            type: 'POST',
                            data: formData,
                            processData: false,
                            contentType: false,
                            success: function(response) {
                                window.location.href = navHref;
                            },
                            error: function(xhr, status, error) {
                                console.error('Error:', error);
                            }
                        });
                    } else {
                        e.preventDefault();
                        let $isInvalid = $form.find('.form-group .is-invalid').first();
                        const formOffset = $isInvalid.offset().top;
                        window.scrollTo({
                            top: formOffset - 100,
                            behavior: "smooth",
                        });
                    }
                });
            });
        });
    }
}